module.exports = __webpack_public_path__ + "img/icon-serve1.dd8f3d16.png";